import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../config";

const HogixxDropbox = ({refs, index, keyDown, data, setData}) => {

  const handleHogixxSelect = (e) => {
    setData((prev) => ({
      ...prev,
      HOGIXX : e.target.value
    }))
  }
  
  return (
    <select
      onKeyDown={(e) => index && keyDown(e, index)}
      ref={(element) => refs && (refs.current[index] = element)} 
      value={data.HOGIXX} 
      id="countries" 
      onChange={handleHogixxSelect} 
      className="dropbox border border-black bg-white text-sm block px-1">
      {
        refs === undefined &&
        <option value="ALL">전체</option>
      }
      <option value="2">2호기</option>
      <option value="3">3호기</option>
    </select>
  )
}
const PkcdxxDropbox = ({refs, index, keyDown, data, setData}) => {
  const [pkcdxxList, setPkcdxxList] = useState();

  const handlePkcdxxSelect = (e) => {
    setData((prev) => ({
      ...prev,
      PKCDXX : e.target.value
    }))  
  }
  const getPkcdxxList = async () => {
    try {
      const resbody = await axios({
        url: `${config.apiUrl}/pkcdxx.do`,
        method: 'get',
      })
      setPkcdxxList({...resbody.data});
    }
    catch(e) {
      console.log(e)
    }
  }
  useEffect(() => {
    getPkcdxxList()
  }, [])
  return (
    <select 
      onKeyDown={(e) => index && keyDown(e, index)}
      ref={(element) => refs && (refs.current[index] = element)} 
      value={data.PKCDXX !== null ? data.PKCDXX : ""} 
      id="countries" 
      onChange={handlePkcdxxSelect} 
      className="dropbox border border-black bg-white text-sm block px-1"
    >
      <option value="">전체</option>
      {
        pkcdxxList && 
        pkcdxxList.resultData.map((data, index) => {
          
          return data.SHNCOD && <option value={data.RCODEX} key={index}>{data.SHNCOD}</option>
        })
      }
    </select>
  )
}

const BsswghDropbox = ({refs, index, keyDown, data, setData}) => {
  const [bsswghList, setBsswghList] = useState();
  
  const handleBsswghSelect = (e) => {
    setData((prev) => ({
      ...prev,
      BSSWGH : e.target.value
    }))
  }
  const getBsswghList = async () => {
    try {
      const resbody = await axios({
        url: `${config.apiUrl}/bsswgh.do`,
        method: 'get',
      }) 
      setBsswghList({...resbody.data});
    }
    catch(e) {
      console.log(e)
    }
  }
  useEffect(() => {
    getBsswghList()
  }, [])
  return (
    <select 
      onKeyDown={(e) => index && keyDown(e, index)}
      ref={(element) => refs && (refs.current[index] = element)} 
      value={data.BSSWGH !== null ? data.BSSWGH : ""} 
      id="countries" 
      onChange={handleBsswghSelect} 
      className="dropbox border border-black bg-white text-sm block px-1">
      <option value="">전체</option>
      {
        bsswghList && 
        bsswghList.resultData.map((data, index) => {
          return data && (<option value={data.RCODEX} key={index}>{data.NMCODX}</option>)
        })
      }
    </select>
  )
}

export {HogixxDropbox, PkcdxxDropbox, BsswghDropbox};